import { WebhookSubscription } from '../models/webhookSubscriptions';
import ApiService from './apiService';

class WebhookSubscriptionService extends ApiService {
  private static instance?: WebhookSubscriptionService;

  private constructor() {
    super();
  }

  static getInstance() {
    if (!WebhookSubscriptionService.instance) {
      WebhookSubscriptionService.instance = new WebhookSubscriptionService();
    }
    return WebhookSubscriptionService.instance;
  }

  getAll(): Promise<WebhookSubscription> {
    return this.client.get(`/configuration/webhook-subscriptions`).then((response) => response.data);
  }

  create(subscription: WebhookSubscription): Promise<WebhookSubscription> {
    return this.client.post(`/configuration/webhook-subscriptions`, subscription).then((response) => response.data);
  }

  delete(): Promise<void> {
    return this.client.delete(`/configuration/webhook-subscriptions`);
  }
}

export default WebhookSubscriptionService;
